import { useContext, useState, ChangeEvent, FormEvent, useEffect } from "react";
import { Box, Button, CircularProgress, TextField } from "@mui/material";
import { Add, Refresh, Remove } from "@mui/icons-material";
// import Feedback from "../feedback";
import { Global_CTX } from "../../contexts/global-ctx";
import {
    Branch_Service,
    INew_Branch,
} from "../../services/branch/branch-service";

import { Autocomplete } from "../Autocomplete/Autocomplete";
import { IOrganization_Row } from "../../services/organization/organization-service";
import UserContext, { User_Type } from "../UserContext";

const initial_input: {
    org: { name: string; code: string } | null;
    selected_org_api_key: string;
    branches: { [idx: number]: INew_Branch };
} = {
    org: null,
    selected_org_api_key: "",
    branches: { 0: { name: "" } },
};

export default function Branch_Form() {
    const [input, set_input] = useState(initial_input);
    const { feedback, set_feedback, set_refetch_counter } =
        useContext(Global_CTX);
    const { user } = useContext(UserContext);
    // const theme = useTheme();

    function handle_change(
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        idx: number
    ) {
        set_input((curr) => ({
            ...curr,
            branches: {
                ...curr.branches,
                [idx]: {
                    ...curr.branches[idx],
                    [event.target.name]: event.target.value,
                },
            },
        }));
    }

    function handle_branch_row(variant: "add" | "remove", idx = 0) {
        if (variant === "add") {
            const new_entry_id =
                Math.max(...Object.keys(input.branches).map(Number)) + 1;

            set_input((curr) => ({
                ...curr,
                branches: {
                    ...curr.branches,
                    [new_entry_id]: initial_input.branches[0],
                },
            }));
        } else if (variant === "remove") {
            if (idx === 0) return;

            set_input((curr) => ({
                ...curr,
                branches: Object.fromEntries(
                    Object.entries(curr.branches).filter(
                        ([key]) => key.toString() !== idx.toString()
                    )
                ),
            }));
        }
    }

    const handle_submit = async (ev: FormEvent) => {
        ev.preventDefault();

        if (!input.org) {
            set_feedback((f) => ({
                loading: false,
                show: true,
                severity: "error",
                message: { title: "Please select an organization." },
            }));
            return;
        }

        set_feedback({ ...feedback, loading: true });

        const [data, error] = await Branch_Service.create_branches(
            Object.values(input.branches),
            input.org.code,
            input.selected_org_api_key
        );

        if (error) {
            set_feedback({
                loading: false,
                message: { title: error.message ?? "" },
                severity: "error",
                show: true,
            });
            return;
        }

        set_refetch_counter((n) => n + 1);

        if (data) {
            set_feedback({
                loading: false,
                message: { title: data.message ?? "" },
                severity: "success",
                show: true,
            });
        }
    };

    useEffect(() => {
        if (user?.user_type === User_Type.Admin) {
            set_input((curr) => ({ ...curr, org: user.organization }));
        }
    }, [user?.user_type]);

    return (
        <form onSubmit={handle_submit}>
            <Box
                display="flex"
                flexDirection="column"
                gap={2}
                mb={2}
                // maxHeight={320}
                // sx={{ overflowY: "auto" }}
            >
                {user?.user_type === User_Type.Superadmin && (
                    <Box flex={1}>
                        <Autocomplete
                            api={"/organization"}
                            setOutput={(org) => {
                                set_input((curr) => ({
                                    ...curr,
                                    org,
                                    // selected_org_api_key:
                                    //     org && org_api_key_map[org.code]
                                    //         ? org_api_key_map[org.code]
                                    //         : "",
                                    branches: Object.fromEntries(
                                        Object.entries(curr.branches).map(
                                            ([idx, branch]) => [
                                                idx,
                                                {
                                                    ...branch,
                                                    name: org
                                                        ? branch.name
                                                        : "",
                                                },
                                            ]
                                        )
                                    ),
                                }));
                            }}
                            labelKey={"name"}
                            label="Organization"
                        />
                    </Box>
                )}

                {Object.entries(input.branches).map(([idx, { name }]) => (
                    <Box display="flex" gap={2} key={`branch-${idx}`}>
                        <TextField
                            label="Branch Name"
                            disabled={!input.org}
                            fullWidth
                            name="name"
                            value={name}
                            onChange={(event) => handle_change(event, +idx)}
                            required
                        />

                        {/* {is_super_admin && (
                                <TextField
                                    label="Organization Code"
                                    fullWidth
                                    name="org_code"
                                    value={org_code}
                                    onChange={(event) =>
                                        handle_change(event, +idx)
                                    }
                                    required
                                />
                            )} */}

                        <Button
                            variant="outlined"
                            onClick={() =>
                                handle_branch_row(
                                    idx.toString() === "0" ? "add" : "remove",
                                    +idx
                                )
                            }
                        >
                            {idx.toString() === "0" ? <Add /> : <Remove />}
                        </Button>
                    </Box>
                ))}
            </Box>

            <Box
            // display="flex" flexDirection="column" gap={2}
            >
                {/* <Button
                    sx={{ mr: 2 }}
                    type="reset"
                    onClick={() => set_input(initial_input)}
                    variant="outlined"
                    disabled={feedback.loading}
                    startIcon={<Refresh />}
                >
                    Reset Form
                </Button> */}

                <Button
                    sx={{ mr: "auto" }}
                    type="submit"
                    variant="contained"
                    disabled={feedback.loading || !input.org}
                    startIcon={
                        feedback.loading ? (
                            <CircularProgress size="1em" />
                        ) : (
                            <Add />
                        )
                    }
                >
                    {feedback.loading ? "Creating Branch..." : "Create Branch"}
                </Button>
            </Box>

            {/* <Feedback /> */}
        </form>
    );
}
